import { gql } from '@apollo/client';

export const GENERATE_AND_SEND_QUOTE = gql`
  mutation GenerateAndSendQuote($contactInformation: ContactInformationInput!, $selectedItems: [SelectedItemInput]!, $paymentMethod: PaymentMethodInput!, $agreementChecked: Boolean!, $adSource: String, $adClickId: String) {
    generateAndSendQuote(contactInformation: $contactInformation, paymentMethod: $paymentMethod, selectedItems: $selectedItems, agreementChecked: $agreementChecked, adSource: $adSource, adClickId: $adClickId) {
      success
      transactionNumber
    }
  }
`;
